/** @format */

// Func = limiting Scope for this file
(function () {

  var burgerMenu = document.getElementById("burger-menu");
  var overlay = document.getElementById("menu");
  burgerMenu.addEventListener("click", function () {
    this.classList.toggle("open");
    overlay.classList.toggle("overlay");
  });

  var burgerMenuClose = document.getElementById("burger-menu-close");
  burgerMenuClose.addEventListener("click", function () {
    this.classList.toggle("close");
    overlay.classList.toggle("overlay");
  });

  $(document).ready(function () {
    // Main Nav Dropdown
    $("#primary-nav li").hover(
      function () {
        $(this).addClass("hover");
        $("ul.submenu", this).fadeIn(200);
      },
      function () {
        $(this).removeClass("hover");
        $("ul.submenu", this).fadeOut(200);
      }
    );

    //fancybox
    $(".fancybox-terms").fancybox({
      wrapCSS: "full-fancy-copy",
      maxWidth: 800,
    });
    window.onload = function () {
      /*this function add a class to header when scroll down the page
      /* and change the logo by a new file if needed depending of mockup 
      */

      scrollDownAction(20, "scroll");

      scrollW();

      window.addEventListener("scroll", function () {
        scrollW();
      });
    };
    
    
    
  });
})();



//Loading preload
// if (document.getElementById("home")) {
//   document.onreadystatechange = function () {
//     let timePreload = 3390;
//     if (window.screen.width > 700) {
//       timePreload = 3390;
//     } else {
//       timePreload = 0;
//     }

//     if (document.readyState === "complete") {
//       setTimeout(function () {
//         console.log(document.readyState);
//         document.documentElement.scrollTop = 0;
//         document.getElementById("preloader-home").classList.add("hide");
//         document.getElementById("preloader-overlay").classList.add("hide");
//       }, timePreload);
//     }
//   };
// }
